import { type CreateConfigurationRequest } from '@types';

import { canUserConfigureReturnToWaitingRoom } from '../../constants';
import { type SessionConfig } from '../../utils/experienceForm/transform';

type BuildExperiencePayloadParams = {
  formValues: SessionConfig;
  transformedConfig: string;
  deviceId: number;
  patientId: number;
  creatorUserId: number;
  sensorId?: number;
};

export function buildExperiencePayload({
  formValues,
  transformedConfig,
  deviceId,
  patientId,
  creatorUserId,
  sensorId,
}: BuildExperiencePayloadParams): CreateConfigurationRequest {
  const parsedSteps = JSON.parse(transformedConfig) as unknown[];
  const payloadConfig = [...parsedSteps];

  if (
    canUserConfigureReturnToWaitingRoom(creatorUserId) &&
    typeof formValues.returnToWaitingRoom === 'boolean'
  ) {
    payloadConfig.push({
      returnToWaitingRoom: formValues.returnToWaitingRoom,
    });
  }

  const payload: CreateConfigurationRequest = {
    config: JSON.stringify(payloadConfig),
    deviceId,
    patientId,
    scenario: '-',
    map: '-',
    type: 'experience',
  };

  if (typeof sensorId === 'number') {
    payload.sensor_id = sensorId;
  }

  return payload;
}
